export default __webpack_public_path__ + "static/media/PigCongrats.de45bebc.png";